export default __webpack_public_path__ + "static/media/Icon-info-circle-full.8d1717a0.svg";